import type { ReactNode } from "react";

// One labeled chip-row wrapper — a sentence heading plus its chips — shared by Tapahtumaloki's
// work-class and entity-kind rows (docs/spec/concepts.md §2.2) so neither reads as unlabeled or is
// mistaken for the other (the entity-kind row wraps EntityKindFilter without editing it, since
// FindingsList shares that control). Not catalogued in docs/reference/patterns.md — a ~10-line
// presentational wrapper (pattern_waiver, story #1289 task #1293). Sentence labels sit above the
// chips in normal case; uppercase tracking made a one-word "Toiminta" / "Missä" look like a
// section code, which hid what each row actually filters.
export function FilterChipRow({
  label,
  children,
  trailing,
}: {
  label: string;
  children: ReactNode;
  trailing?: ReactNode;
}) {
  return (
    <div className="flex flex-col gap-1 min-w-0">
      <span className="text-xs text-muted-foreground">{label}</span>
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
        <div className="flex flex-wrap items-center gap-1">{children}</div>
        {trailing ? (
          <div className="ml-auto flex flex-wrap items-center gap-1">
            {trailing}
          </div>
        ) : null}
      </div>
    </div>
  );
}
